import { ElementType } from 'react';
import { DrawerWidths } from 'src/config-global';
import { TodoRightMenu } from 'src/pages/dashboard/TodosPage/shared/TodoRightMenu/TodoRightMenuDrawer';
import { TodosContextProvider } from 'src/provider/TodosContext';
import { ChatActionBar } from '../Chat/ChatActionBar';
import { ChatIA } from '../ChatIA';
import { Cloud } from '../Cloud';
import { DocActionBarDrawer } from '../Docs/DocActionBarDrawer';
import { GatheringChat } from '../Gathering/GatheringChat';
import { GatheringParticipants } from '../Gathering/GatheringParticipants/GatheringParticipants';
import { TranscriptionRightMenuDrawer } from '../Transcriptions';
import { Action } from './types';

export const actionsComponent: Record<Action, ElementType> = {
  openai: ChatIA,
  cloud: ({ onClose }) => <Cloud onClose={onClose} />,
  todo: ({ onClose }) => (
    <TodosContextProvider>
      <TodoRightMenu onClose={onClose} />
    </TodosContextProvider>
  ),
  gathering: ({ onClose, isGuest }) => (
    <GatheringParticipants onClose={onClose} isGuest={isGuest} />
  ),
  gatheringChat: ({ onClose, isGuest }) => (
    <GatheringChat onClose={onClose} isGuest={isGuest} />
  ),
  chat: ({ onClose }) => <ChatActionBar onClose={onClose} />,
  notes: ({ onClose }) => <TranscriptionRightMenuDrawer onClose={onClose} />,
  doc: ({ onClose }) => <DocActionBarDrawer onClose={onClose} />,
};

export const drawerSize: Record<Action, DrawerWidths> = {
  openai: DrawerWidths.LARGE_WIDTH,
  cloud: DrawerWidths.MEDIUM_WIDTH,
  todo: DrawerWidths.MEDIUM_WIDTH,
  gathering: DrawerWidths.MEDIUM_WIDTH,
  gatheringChat: DrawerWidths.LARGE_WIDTH,
  chat: DrawerWidths.LARGE_WIDTH,
  notes: DrawerWidths.LARGE_WIDTH,
  doc: DrawerWidths.LARGE_WIDTH,
};
